/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stretch_ShrinkInputs */



/**
* | output |
* | --- |
* | "Stretch/Shrink..." |
*
* @param {Stretch_ShrinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const stretch_shrink = /** @type {((inputs?: Stretch_ShrinkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stretch_ShrinkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Étirer/Réduire...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dehnen/Schrumpfen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allungare/Restringere...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Растяжение/сжатие...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estirar/Encoger...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拉伸/收缩……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("伸縮...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खिंचाव/सिकुड़न...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esticar/Encolher...")
	return /** @type {LocalizedString} */ ("Stretch/Shrink...")
});